module.exports = __webpack_public_path__ + "media/images/river/perfect-fit-1eb53400ee8b8c5f38311dc973900b40.png";